import React from "react"
import {useSelector} from "react-redux";

const UnreadSupportChatMessages = ({ignoreCompletedSessions}) => {
  const supportChatSessions = useSelector(state => state.supportChatSessions)
  const supportChatMessages = useSelector(state => state.supportChatMessages)
  let unreadSupportChatMessages = supportChatMessages.filter(supportChatMessage => !supportChatMessage.read_by_tag_owner)

  if (ignoreCompletedSessions) {
    const notCompletedSessions = supportChatSessions.filter(supportChatSession => !supportChatSession.complete)
    unreadSupportChatMessages = unreadSupportChatMessages.filter(supportChatMessage => notCompletedSessions.some(session => session.id === supportChatMessage.support_chat_session_id))
  }

  const unreadSupportChatMessagesCount = unreadSupportChatMessages.length;

  if (unreadSupportChatMessagesCount > 0) {
    return <div className={"unread-support-chat-messages"}>
      {unreadSupportChatMessagesCount}
    </div>
  }

  return null;
}

export default UnreadSupportChatMessages